@if(!!selectedStock()){

<div class="stock-wrapper other-store">
  <div class="stock-row title">
    <button class="btn btn-rounded btn-light" (click)="handleSelectStock(null)">
      <img src="assets/icons/back.svg" alt="">
    </button>
    <span>{{selectedStock()?.storeName}}&nbsp;{{selectedStock()?.store}}</span>
  </div>
</div>
@if(selectedStock()){
<app-my-store-stock [storeStock]="selectedStock"></app-my-store-stock>
}

}@else {

<div class="stock-wrapper other-store">

  <div class="stock-row title">
    <span>{{"STORES"|translate}}</span>
  </div>

  <div class="stores">

    @for(store of storeStocks(); track store.idStore){

    <app-stock-button [text]="store.storeName + ' - ' + store.store"
      [counters]="stockAndPriceService.getStockCounters(store)"
      (handleClick)="handleSelectStock(store)"></app-stock-button>

    }


  </div>
</div>

@if(storeStocks().length > 0){
<app-stock-button class="total" [text]="'TOTAL'|translate" [counters]="total()" [isTotal]="true"></app-stock-button>
}


}
